import React, { useState, useRef, useEffect } from "react";
// import Controls from './Controls';
import Details from "./Details";
import { useNavigate, useParams } from "react-router-dom";

function Player(props) {
  const audioEl = useRef(null);
  const { contestId, id } = useParams();
  const navigate = useNavigate();
  const pageType = window.location.pathname.split("/")[1];
  console.log("out", parseInt(id));

  const nextPage = () => {
    console.log(pageType);
    console.log(parseInt(id));
    for (let i = 50; i >= 0; i--) {
      window.clearTimeout(i);
    }
    if (pageType === "round") {
      switch (parseInt(id)) {
        case 1: // SongPage
          navigate(`/song/${parseInt(id) + 2}/${contestId}`);
          break;
        case 2: // SongPage
          navigate(`/song/${parseInt(id) + 3}/${contestId}`);
          break;
        case 3: // SongPage
          navigate(`/song/${parseInt(id) + 4}/${contestId}`);
          break;
        case 4: // ClosingPage
          navigate(`/final/${contestId}`);
          break;
        default:
      }
    } else if (pageType === "song") {
      switch (parseInt(id)) {
        case 1: // SongPage
        case 3:
        case 5:
        case 7:
          navigate(`/song/${parseInt(id) + 1}/${contestId}`);
          break;
        case 2: // VotePage
          navigate(`/round/${parseInt(id) - 1}/${contestId}`);
          break;
        case 4: // VotePage
          navigate(`/round/${parseInt(id) - 2}/${contestId}`);
          break;
        case 6: // VotePage
          navigate(`/round/${parseInt(id) - 3}/${contestId}`);
          break;
        case 8: // VotePage
          navigate(`/round/${parseInt(id) - 4}/${contestId}`);
          break;
        default:
      }
    }
  };

  const [isPlaying, setIsPlaying] = useState(false);

  const playSong = () => {
    try {
      audioEl.current.play();
      if (pageType === "song") {
        const time = setTimeout(nextPage, 30000);
        console.log("Timer", time);
        return () => {
          console.log("Time out", time);
          window.clearTimeout(time);
        };
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (isPlaying) {
      try {
        audioEl.current.play();
        if (pageType === "song") {
          const time = setTimeout(nextPage, 30000);
          console.log("Timer ", time);
          return () => {
            console.log("Time out", time);
            window.clearTimeout(time);
          };
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      audioEl.current.pause();
    }
  });

  const SkipSong = (forwards = true) => {
    if (forwards) {
      props.setCurrentSongIndex(() => {
        let temp = props.currentSongIndex;
        temp++;

        if (temp > props.songs.length - 1) {
          temp = 0;
        }

        return temp;
      });
    } else {
      props.setCurrentSongIndex(() => {
        let temp = props.currentSongIndex;
        temp--;

        if (temp < 0) {
          temp = props.songs.length - 1;
        }

        return temp;
      });
    }
  };

  return (
    <div className="c-player">
      <audio
        autoPlay
        src={props.songs[props.currentSongIndex].audioLink}
        ref={audioEl}
      ></audio>
      <Details
        id={props.id}
        buttonText={props.buttonText}
        sendVoting={props.sendVoting}
        song={props.songs[props.currentSongIndex]}
        isPlaying={isPlaying}
        setIsPlaying={setIsPlaying}
        SkipSong={SkipSong}
        playSong={playSong}
      />
    </div>
  );
}

export default Player;
